$(function () {
  $('div[role=tablist] a').on('click', function () {
    $(this).removeClass('active')
  })
})
